import './mail-qualification-workspace.ajscss';

import { IEpticaDeprecatedService } from '@agent/core/channel-digit/mail/eptica/eptica-deprecated.service';
import { EpticaHelper } from '@agent/core/channel-digit/mail/eptica/eptica.helper';
import { IEpticaRequestFrame } from '@agent/core/channel-digit/mail/eptica/models/eptica.request.interfaces';
import { IAppointmentDeprecatedService } from '@agent/core/contact/appointment-deprecated.service';
import { IContactDeprecatedService } from '@agent/core/contact/contact-deprecated.service';
import { IComponentController, IComponentOptions, IPromise, IQService, ITimeoutService } from 'angular';
import moment from 'moment';

import {
  ChannelDirection,
  ChannelType,
  deepCopy,
  MomentService,
  None,
  Option,
  Reschedule,
  RescheduleReason,
  RescheduleTarget,
  Writable,
} from '@contact/upgrade';

import templateUrl from './mail-qualification-workspace.template.html';

const MODULE_NAME = 'contactMailQualifWorkspace';

class MailQualificationWorkspaceCtrl implements IComponentController {
  public name = MODULE_NAME;

  responseId: string;

  canBeRescheduled: boolean = false;
  canBeReassigned: boolean = false;
  isCampaignContact: boolean = false;
  reschedule: Writable<Reschedule> = {
    reason: RescheduleReason.PROCESSED,
    time: 0,
    date: new Date().getTime(),
    description: '',
    target: RescheduleTarget.INDIFFERENT,
  };
  availablerescheduleTimes: number[] = [];
  campaignEndDate: Date;
  private requestPromise: IPromise<IEpticaRequestFrame>;
  private timeout;
  constructor(
    private readonly $q: IQService,
    private readonly $timeout: ITimeoutService,
    private readonly contactDeprecatedService: IContactDeprecatedService,
    private readonly appointmentDeprecatedService: IAppointmentDeprecatedService,
    private readonly epticaDeprecatedService: IEpticaDeprecatedService,
    private readonly momentService: MomentService
  ) {}

  $onInit(): void {
    this.requestPromise = this.contactDeprecatedService
      .getContact(this.responseId)
      .then(contact => {
        this.canBeRescheduled = contact.campaign?.canBeRescheduled ?? false;
        this.canBeReassigned = contact.campaign?.canBeReassigned ?? false;
        this.isCampaignContact =
          Option.of(contact.campaign)
            .map(campaign => campaign.campaign.id)
            .getOrElse('') !== '' &&
          contact.channel.direction === ChannelDirection.OUTGOING &&
          contact.channel.type === ChannelType.MAIL;
        if (this.canBeRescheduled && this.isCampaignContact) {
          this.campaignEndDate = Option.of(contact.campaign)
            .map(campaign => new Date(campaign.campaign.endDate))
            .getOrElse(new Date());
          if (contact.campaign) {
            this.appointmentDeprecatedService
              .retrieveRescheduleTimesForDay(contact.campaign.campaign.id, new Date(this.reschedule.date))
              .then(availablerescheduleTimes => {
                this.availablerescheduleTimes = availablerescheduleTimes;
              });
          }
          if (!contact.reschedule) {
            if (this.availablerescheduleTimes.length > 0) {
              this.reschedule = {
                ...this.reschedule,
                time: this.availablerescheduleTimes[0],
              };
            }
            if (!this.canBeReassigned) {
              this.reschedule = {
                ...this.reschedule,
                target: RescheduleTarget.SELF,
              };
            }
            contact = {
              ...contact,
              reschedule: this.reschedule,
            };
          } else {
            this.reschedule = deepCopy(contact.reschedule);
          }
        }
        return contact;
      })
      .then(contact => EpticaHelper.delay(this.$q, this.$timeout, 3000, contact))
      .then(contact => {
        if (contact.epticaRequestId != null) {
          return this.epticaDeprecatedService.loadRequestUntil({
            requestId: contact.epticaRequestId,
            responseId: this.responseId,
          });
        } else {
          // epticaRequestId can be null for outgoing mail for exemple
          return this.$q.reject('contact Id is null');
        }
      });
  }

  $onDestroy(): void {
    this.requestPromise.then(request => {
      request.hide();
      request.finish();
    });
  }

  getReadableTime(time: number): string {
    return this.momentService.readableTime(moment(time).utc().toDate());
  }

  valueChanged() {
    Option.of(this.timeout).forEach(t => clearTimeout(t));
    this.timeout = setTimeout(() => {
      this.contactDeprecatedService.updateReschedule(this.responseId, this.reschedule, None, None);
      this.timeout = null;
    }, 500);
  }
}

export class MailQualificationWorkspace implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
  };
  controller = [
    '$q',
    '$timeout',
    'contactDeprecatedService',
    'appointmentDeprecatedService',
    'epticaDeprecatedService',
    'momentService',
    MailQualificationWorkspaceCtrl,
  ];
}

export default MODULE_NAME;
